import React, { Component } from "react";
import TableComp from '../../../../components/_utils/table'
// import {TableComp} from "sz-react-utils";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
import moment from "moment";
import { Button, Card, Col, DatePicker, notification, Popconfirm, Row, Form, Drawer, Select, Switch, Tooltip } from "antd";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import { Link } from "react-router-dom";
import _ from 'lodash';
import Request, { API_URL, LAPI_URL, MEDIA_URL } from "../../../../request";
import { connect } from "react-redux";
import styles from "../../course/all/styles.less";
import common from "../../../common.less";
import setting from "../../../../components/_utils/settings";
import rightAuth from "../../../../components/_utils/userRights";
import { RightsWrapper } from "../../../../components/_utils/utils";
import TransferCourse from '../../../../components/_utils/transferCourse';
import CourseImportExcel from '../../../../assets/samplesFiles/CourseImport.xlsx'

const CourseRestoreView = rightAuth.checkRights('CourseRestore.view');
const CourseRestoreDelete = rightAuth.checkRights('CourseRestore.delete');

const companyDetails = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : null;

const { RangePicker } = DatePicker

const Option = Select.Option;

class CourseFactSheet extends Component {
    state = {
        visible: true,
        universityData: {}
    }

    loadApis = async () => {
        let { record } = this.props;
        let response = await Request.getCourseDetailsForFact({ _id: record._id });
        this.setState({ universityData: response.doc })
    }

    componentDidMount() {
        this.loadApis();
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 50)
    }


    downloadInvoice = () => {
        const printContents = document.getElementById('table_with_data').innerHTML;

        // Open a new window
        const printWindow = window.open('', '_blank', 'width=800,height=600');

        // Write the contents to the new window
        printWindow.document.open();
        printWindow.document.write(`
          <html>
            <head>
              <title>Fact Sheet Of ${this.props.record.courseName}</title>
              <style>
                /* Add any styles you want for printing */
                body {
                  font-family: Arial, sans-serif;
                }
                table {
                  width: 100%;
                  border-collapse: collapse;
                }
                table, th, td {
                  border: 1px solid black;
                }
                th, td {
                  padding: 8px;
                  text-align: left;
                }
              </style>
            </head>
            <body>
              ${printContents}
            </body>
          </html>
        `);
        printWindow.document.close();

        // Print the new window
        printWindow.print();

        // Optionally close the print window after printing
        printWindow.onafterprint = () => {
            printWindow.close();
        };
    };


    render() {
        let { visible, universityData } = this.state;
        let { record } = this.props;
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Fact Sheet of {record.courseName}
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1000}
                visible={visible}>
                <Card>
                    <Tooltip title="Download Invoice">
                        <Button
                            loading={false}
                            shape="circle"
                            icon="download"
                            onClick={() => { this.downloadInvoice() }}
                        />
                    </Tooltip>
                    <Card id="table_with_data" loading={!this.state.universityData}>
                        {/* Course Name */}
                        <div style={{ textAlign: 'center' }}><h2 style={{ textDecoration: 'underline', fontWeight: 'bold' }}>{universityData && universityData.course ? universityData.course.courseName : null}</h2></div>
                        {/* Company Logo */}
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
                            <img style={{ width: '120px' }} src={universityData && universityData.contactLogo && universityData.contactLogo.length ? `${API_URL}${universityData.contactLogo[0].url}` : null} />
                            <img style={{ width: '140px' }} src={companyDetails && companyDetails.companyLogo ? companyDetails.companyLogo : null} />
                        </div>
                        {/* Course Details */}
                        <div style={{ width: '100%', textAlign: 'left', marginTop: 30 }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', border: 'none', margin: '0' }}>
                                <tbody>
                                    {/* University Name */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>University</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{universityData.universityInstitutionName ? universityData.universityInstitutionName : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* University Website */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Website</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{universityData.universityWebsite ? universityData.universityWebsite : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Application Fee */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Application Fee</span></strong></p>
                                        </td>
                                        {
                                            record.differentApplicationFee ?
                                                <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                    <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}>
                                                        <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>UG:- {universityData && universityData.contactApplicationFeeUG} {universityData && universityData.course && universityData.course.currencyName ? universityData.course.currencyName : null}</span></strong>
                                                    </p>
                                                    <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}>
                                                        <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>PG:- {universityData && universityData.contactApplicationFeePG} {universityData && universityData.course && universityData.course.currencyName ? universityData.course.currencyName : null}</span></strong>
                                                    </p>
                                                </td>
                                                :
                                                <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                    <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}>
                                                        <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{universityData && universityData.waiveApplicationFee ? 'Waived Off' : universityData && universityData.contactAppilcationFee} {universityData && universityData.course && universityData.course.currencyName ? universityData.course.currencyName : null}</span></strong>
                                                    </p>
                                                </td>
                                        }
                                    </tr>
                                    {/* Course Duration */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Duration</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{universityData && universityData.course && universityData.course.courseDuration ? universityData.course.courseDuration : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Annual Tution Fee */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Annual Tution Fee</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{universityData && universityData.course && universityData.course.tutionFee ? universityData.course.tutionFee : null} {universityData && universityData.course && universityData.course.currencyName ? universityData.course.currencyName : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Payable  */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Payable</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{universityData && universityData.course && universityData.course.payable ? universityData.course.payable : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Intakes */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Intakes</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{universityData && universityData.course && universityData.course.intakes ? universityData.course.intakes.map(intake => moment(intake).format('MMM')).join(', ') : null}</span></strong></p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* Academic Requirements */}
                        <div style={{ textAlign: 'center', marginTop: 30 }}><h3 style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Academic Requirements</h3></div>
                        <div style={{ width: '100%', textAlign: 'left', marginTop: 30 }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', border: 'none', margin: '0' }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                                                <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Qualification</span></strong>
                                            </p>
                                        </th>
                                        <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                                                <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Stream</span></strong>
                                            </p>
                                        </th>
                                        <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                                                <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Grading System</span></strong>
                                            </p>
                                        </th>
                                        <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                                                <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Score</span></strong>
                                            </p>
                                        </th>
                                        <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                                                <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Maths</span></strong>
                                            </p>
                                        </th>
                                        <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                                                <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>English</span></strong>
                                            </p>
                                        </th>
                                        <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                                                <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Backlogs</span></strong>
                                            </p>
                                        </th>
                                        <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                                                <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Degree</span></strong>
                                            </p>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {universityData && universityData.course && universityData.course.qualification && universityData.course.qualification.length ?
                                        universityData.course.qualification.map((quali) => (
                                            <tr>
                                                <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                    <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{quali.qualification ? quali.qualification : null}</span></strong></p>
                                                </td>
                                                <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                    <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{quali.stream && quali.stream.length ? quali.stream.map(qual => qual).join(', ') : null}</span></strong></p>
                                                </td>
                                                <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                    <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{quali && quali.gradingSystem ? quali.gradingSystem : 'Percentage'}</span></strong></p>
                                                </td>
                                                <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                    <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{quali && quali.score ? quali.score : null}</span></strong></p>
                                                </td>
                                                <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                    <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{quali && quali.maths ? quali.maths : null}</span></strong></p>
                                                </td>
                                                <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                    <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{quali && quali.english ? quali.english : null}</span></strong></p>
                                                </td>
                                                <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                    <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{quali && quali.backlogs ? quali.backlogs : null}</span></strong></p>
                                                </td>
                                                <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                    <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{quali && quali.degreeType ? quali.degreeType : null}</span></strong></p>
                                                </td>
                                            </tr>
                                        ))
                                        : null}
                                </tbody>
                            </table>
                        </div>
                        {/* Ielts Requirement */}
                        <div style={{ textAlign: 'center', marginTop: 30 }}><h3 style={{ textDecoration: 'underline', fontWeight: 'bold' }}>English Requirements</h3></div>
                        <div style={{ width: '100%', textAlign: 'left', marginTop: 30 }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', border: 'none', margin: '0' }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                                                <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Exam</span></strong>
                                            </p>
                                        </th>
                                        <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                                                <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Overall</span></strong>
                                            </p>
                                        </th>
                                        <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                                                <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Listening</span></strong>
                                            </p>
                                        </th>
                                        <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                                                <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Reading</span></strong>
                                            </p>
                                        </th>
                                        <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                                                <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Writing</span></strong>
                                            </p>
                                        </th>
                                        <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                                                <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Speaking</span></strong>
                                            </p>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {universityData && universityData.course && universityData.course.ieltsRequirements && universityData.course.ieltsRequirements.length ?
                                        universityData.course.ieltsRequirements.map((iel) => (
                                            <tr>
                                                <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                    <p style={{ margin: '0cm', textAlign: 'center', marginBottom: '.0001pt', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{iel.ExamType ? iel.ExamType : null}</span></strong></p>
                                                </td>
                                                <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                    <p style={{ margin: '0cm', textAlign: 'center', marginBottom: '.0001pt', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{iel.Overall ? iel.Overall : null}</span></strong></p>
                                                </td>
                                                <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                    <p style={{ margin: '0cm', textAlign: 'center', marginBottom: '.0001pt', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{iel.Listening ? iel.Listening : null}</span></strong></p>
                                                </td>
                                                <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                    <p style={{ margin: '0cm', textAlign: 'center', marginBottom: '.0001pt', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{iel.Reading ? iel.Reading : null}</span></strong></p>
                                                </td>
                                                <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                    <p style={{ margin: '0cm', textAlign: 'center', marginBottom: '.0001pt', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{iel.Writing ? iel.Writing : null}</span></strong></p>
                                                </td>
                                                <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                    <p style={{ margin: '0cm', textAlign: 'center', marginBottom: '.0001pt', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{iel.Speaking ? iel.Speaking : null}</span></strong></p>
                                                </td>
                                            </tr>
                                        ))
                                        : null}
                                </tbody>
                            </table>
                        </div>
                        {/* Additional Requirements & Others */}
                        <div style={{ width: '100%', textAlign: 'left', marginTop: 30 }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', border: 'none', margin: '0' }}>
                                <tbody>
                                    {/* Additional Requirements */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Additional Requirements</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{universityData && universityData.course && universityData.course.additionalRequirements ? universityData.course.additionalRequirements : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Course Url */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Course URL</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{universityData && universityData.course && universityData.course.courseURL ? <a target="_blank" href={universityData.course.courseURL}>{universityData.course.courseURL}</a> : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Basic Admission Documents */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'center' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Basic Admission Documents</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{universityData && universityData.enrollmentDocuments ? universityData.enrollmentDocuments : null}</span></strong></p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Card>
                </Card>
            </Drawer>
        )
    }
}



@Form.create()
class AllCourse extends Component {
    state = {
        total: 0,
        uniArr: [],
        courseUniversityId: "",
        printLoading: {},
        showDelete: false,
        restoreLoading: false,
        showTransferForm: false,
        courseId: '',
        universityId: '',
        visible1: false,
        showMissingQual: false,
        showCourseFactSheetDrawer: false,
        recordFactSheet: {},
        exportParams: null
    };


    exportExcel = async () => {
        let { exportParams } = this.state;
        let x = await Request.exportAllCourses(exportParams);
        if (!x.error) {
            window.open(x.url)
        }
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            if (this.state.showMissingQual) {
                params.showMissingQual = this.state.showMissingQual
            }
            if (this.state.courseUniversityId) {
                params.courseUniversityId = this.state.courseUniversityId;
                //params.page=1;
            }
            if (params.sortField && params.sortField == "courseName") {
                params.sortField = "course.courseName";
            }

            if (params.sortField && params.sortField == "universityInstitutionName") {
                params.sortField = "course.universityInstitutionName";
            }

            if (params.sortField && params.sortField == "tutionFee") {
                params.sortField = "course.tutionFee";
            }
            params.showDelete = this.state.showDelete;
            this.setState({ exportParams: params });
            let data = await Request.getAllCourse({
                ...params,
                regExFilters: [
                    "courseName",
                    "universityInstitutionName",
                    "tutionFee",
                    "updatedByUser.name",
                    "createdByUser.name",
                ],
                dateFilter: this.state.time
            });
            this.setState({ total: data.total });

            resolve(data);
        });
    };

    chooseRangerPicker = (date, dateString) => {
        this.setState({
            time: {
                key: 'time',
                from: date[0],
                to: date[1]
            }
        })
        if (date[0] == undefined) {
            setTimeout(() => {
                this.table.current.reload()
            }, 500)
        }
    }
    onOk = value => {
        this.table.current.reload();
    }

    changeCourseStatus = async ({ checked, _id, universityInstitutionId }) => {
        await Request.changeCourseStatus({
            _id,
            status: checked,
            universityInstitutionId,
        });
        this.table.current.reload();
    };

    loadUni = async () => {
        let arr = await Request.loadSimpleUniversities();
        console.log(arr);
        let allUniversities = [];
        _.each(arr.arr, (university) => {
            allUniversities.push({ _id: university._id, universityInstitutionName: university.universityInstitutionName, display: `${university.universityInstitutionName} ${university.consortiumId ? `-${university.consortiumId.consortiumName}` : null}` })
        })

        this.setState({ uniArr: allUniversities });
    };
    onUniChoose = (v) => {
        this.setState({ courseUniversityId: v }, () => {
            this.table.current.reload();
        });
    };
    printCourseDetails = async (data) => {
        let printLoading = this.state.printLoading;
        printLoading[data._id] = true;
        this.setState({ printLoading: printLoading })
        let resp = await Request.printCourseDetails(data)
        printLoading[data._id] = false;
        this.setState({ printLoading: printLoading })

        if (resp && resp.pdfName) {
            window.open(`${MEDIA_URL}storage/${resp.pdfName}`);
        } else {
            notification.error({
                message: "Error",
                description: "Try again",
            });
        }
    };


    viewCourseDetails = async (data) => {
        this.setState({ showCourseFactSheetDrawer: true, recordFactSheet: data })
    }

    closeCourseFactSheetDrawer = () => {
        this.setState({ showCourseFactSheetDrawer: false, recordFactSheet: {} }, () => {
            this.table.current.reload();
        })
    }

    handleTransfer = (courseId) => {
        return (
            this.setState({ showTransferForm: true, courseId: courseId._id, universityId: courseId.universityInstitutionId })
        )
    }

    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()

        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {

                let values = _.clone(valData)

                let x = null

                x = await Request.addCourseFromExcelData(values)

                if (!x.error) {
                    notification.success({
                        message: x.message
                    })

                    this.setState({ visible1: false })
                    this.table.current.reload()
                } else {
                    notification.error({
                        message: x.message

                    })
                }
            }
        })
    }

    handleDelete = (courseId) => {
        Request.deleteCourse(courseId)
            .then(x => {

                if (x.success) {
                    notification.success({
                        message: x.msg,
                        description: x.msg
                    })
                } else {
                    notification.error({
                        message: 'Error',
                        description: x.msg
                    })
                }
                this.table.current.reload()
            })
            .catch(err => {
                notification.error({
                    message: 'Error',
                    description: 'Some Error'
                })
            })
    }

    closeTransferForm = () => {
        this.setState({ showTransferForm: false, courseId: '' });
        this.table.current.reload()
    }

    restoreCourse = (courseId) => {
        Request.restoreCourse(courseId)
            .then(x => {

                if (x.success) {
                    notification.success({
                        message: x.msg,
                        description: x.msg
                    })
                } else {
                    notification.error({
                        message: 'Error',
                        description: x.msg
                    })
                }
                this.table.current.reload()
            })
            .catch(err => {
                notification.error({
                    message: 'Error',
                    description: 'Some Error'
                })
            })
    }
    constructor(props) {
        super(props);
        this.loadUni();
        this.table = React.createRef();
    }



    componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search);

        if (searchParams.get("courseUniversityId")) {
            setTimeout(() => {
                this.setState(
                    { courseUniversityId: searchParams.get("courseUniversityId") },
                    () => {
                        this.table.current.reload();
                    }
                );
            }, 1000);
        } else {
        }
    }

    render() {
        let { dispatch } = this.props;
        const { printLoading } = this.state;
        const inputTypes = {
            fields: [
                {
                    label: 'Select University', key: 'universityId', required: true, showSearch: true, type: 'select', options: this.state.uniArr, onChange: v => {
                        this.props.form.setFieldsValue({ universityId: v })
                    }
                },
                { label: 'Choose Excel File', key: 'excelFile', type: 'file', required: true }
            ]
        }
        const {
            form: { getFieldDecorator, getFieldValue }
        } = this.props
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
                md: { span: 8 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
                md: { span: 12 }
            }
        }
        const columns = [

            {
                title: "Course",
                key: "courseName",
                dataIndex: "courseName",
                width: 200,
                fixed: "left",
                sorter: true,
                searchTextName: "Course Name",
                filterRegex: true,
                render: (val, record) => {
                    return (
                        <React.Fragment>
                            {rightAuth.checkRights("Course.edit") ? (
                                <RightsWrapper myRight={"Course.edit"}>
                                    <Tooltip title="Click To Edit Details">
                                        <a
                                            href={`/master/edit-course?id=${record._id}`}
                                        >
                                            {val}
                                        </a>
                                    </Tooltip>
                                </RightsWrapper>
                            ) : (
                                <React.Fragment>{val}</React.Fragment>
                            )}
                        </React.Fragment>
                    );
                },
            },
            {
                title: "View Summary",
                key: "viewSummery",

                width: 150,
                render: (text, record) => (
                    <React.Fragment>
                        <Tooltip title="View Fact Sheet">
                            <Button
                                key={record.id}
                                loading={printLoading[record._id]}
                                className={styles.btn}
                                shape="circle"
                                onClick={() => {
                                    this.viewCourseDetails(record);
                                    // this.printCourseDetails(record);
                                }}
                                icon="eye"
                            />
                        </Tooltip>
                        <Tooltip title="Fact Sheet">
                            <Button
                                key={record.id}
                                loading={printLoading[record._id]}
                                className={styles.btn}
                                shape="circle"
                                onClick={() => {
                                    this.printCourseDetails(record);
                                }}
                                icon="download"
                            />
                        </Tooltip>
                    </React.Fragment>
                ),
            },
            {
                title: "University",
                width: 150,
                key: "universityInstitutionName",
                dataIndex: "universityInstitutionName",
                sorter: true,
                searchTextName: "University Name",
                render: (val, row) => {
                    return (
                        <div>
                            <div>{row.universityInstitutionName}</div>
                            <small>({row.universityCountryId})</small>
                        </div>
                    );
                },
            },
            {
                title: "Status",
                dataIndex: "status",
                key: "status",
                width: 100,
                render: (val, record) => {
                    return (
                        <div className={styles.wrap}>
                            <Switch
                                checked={record.status == "Active" ? true : false}
                                onChange={(checked) => {
                                    this.changeCourseStatus({
                                        checked,
                                        _id: record._id,
                                        universityInstitutionId: record.universityInstitutionId,
                                    });
                                }}
                            />
                        </div>
                    );
                },
            },
            {
                title: "Duration/Fee Per Year",
                key: "tutionFee",
                dataIndex: "duration",
                width: 100,
                searchTextName: "Tution Fee",
                render: (val, record) => {
                    return (
                        <div>
                            <div>{record.courseDuration} /</div>
                            <div>{record.tutionFee}</div>
                        </div>
                    );
                },
            },
            {
                title: "Main Campus",
                width: 100,
                key: "maincampus",
                dataIndex: "maincampus",
                render: (val, record) => {
                    return (
                        <ul className={common.ul}>
                            {record.mainCampus && record.mainCampus.map((val, inde) => {
                                return <li key={inde}>{val}</li>;
                            })}
                        </ul>
                    );
                },
            },
            {
                title: "English Requirement",
                width: 150,
                key: "ielts",
                dataIndex: "ielts",
                render: (val, record) => {
                    return (
                        <div>
                            <table class="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td style={{ fontSize: 10 }}>#</td>
                                        <td style={{ fontSize: 10 }}>O</td>
                                        <td style={{ fontSize: 10 }}>R</td>
                                        <td style={{ fontSize: 10 }}>W</td>
                                        <td style={{ fontSize: 10 }}>S</td>
                                        <td style={{ fontSize: 10 }}>L</td>
                                    </tr>
                                    {record.ieltsRequirements && record.ieltsRequirements.map((item, c) => {
                                        return (
                                            <tr key={c}>
                                                <td style={{ fontSize: 8 }}> {item.ExamType}</td>
                                                <td style={{ fontSize: 10 }}> {item.Overall}</td>
                                                <td style={{ fontSize: 10 }}> {item.Reading}</td>
                                                <td style={{ fontSize: 10 }}> {item.Writing}</td>
                                                <td style={{ fontSize: 10 }}> {item.Speaking}</td>
                                                <td style={{ fontSize: 10 }}> {item.Listening}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    );
                },
            },

            {
                title: "Academic Requirements",
                width: 100,
                key: "academic",
                dataIndex: "academic",
                render: (val, record) => {
                    return (
                        <div>
                            {record.qualification &&
                                record.qualification.map((item, c) => {
                                    return (
                                        <div key={c}>
                                            <div>
                                                <small>Name: {item.qualification}</small>
                                            </div>
                                            <div>
                                                <small>Grading: {item.gradingSystem}</small>
                                            </div>
                                            <div>
                                                <small>Score: {item.score}</small>
                                            </div>
                                            <div>
                                                <small>Maxi Backlog: {item.backlogs}</small>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    );
                },
            },
            {
                title: "Intakes",
                width: 200,
                key: "intakes",
                dataIndex: "intakes",
                render: (val, record) => {
                    return (
                        <ul className={common.ul}>
                            {record.intakes && record.intakes.map((val, inde) => {
                                return <li key={inde}>{moment(val).format("MMM")}</li>;
                            })}
                        </ul>
                    );
                },
            },
            {
                title: "Updated By",
                width: 150,
                key: "updatedByUser",
                dataIndex: "updatedByUser",
                searchTextName: "Updated By",
                render: (text, record) => {
                    return (
                        <div>
                            <div className={common.user}>{text ? text.name : ""} </div>
                            <small>
                                {text ? moment(text.time).local().format(setting.masterFormat) : ""}
                            </small>
                        </div>
                    );
                },
            },
            {
                title: "Created By",
                width: 150,
                key: "createdByUser",
                dataIndex: "createdByUser",
                searchTextName: "Created By",
                render: (text, record) => {
                    return (
                        <div>
                            <div className={common.user}>{record.createdByUser ? record.createdByUser.name : record.updatedByUser ? record.updatedByUser.name : ""} </div>
                            <small>
                                {record.createdByUser ? moment(record.createdByUser.time).local().format(setting.masterFormat) : record.updatedByUser ? moment(record.updatedByUser.time).format(setting.masterFormat) : ""}
                            </small>
                        </div>
                    );
                },
            },
            {
                title: "Pathways",
                width: 150,
                key: "pathways",
                dataIndex: "pathways",
                render: (val, record) => {
                    return (
                        // style={{maxHeight:200,overflowY:'scroll'}}
                        <div>
                            {record.pathways && record.pathways.length
                                ? record.pathways.map((item, c) => {
                                    return (
                                        <div key={c}>
                                            <div>
                                                <small>Course :{item.pathCourse}</small>
                                            </div>
                                            <div>
                                                <small>University :{item.pathUniversity}</small>
                                            </div>
                                            <div>
                                                <small>Deposit :{item.pathDeposit}</small>
                                            </div>
                                            <div>
                                                <small>Duration :{item.pathDuration}</small>
                                            </div>
                                            <div>
                                                <small>Url :{item.pathUrl}</small>
                                            </div>
                                        </div>
                                    );
                                })
                                : null}
                        </div>
                    );
                },
            },
            {
                title: 'Action',
                key: 'operation',
                width: 150,
                render: (text, record) => (
                    <React.Fragment>
                        {
                            this.state.showDelete == false ?
                                <>
                                    <Tooltip title="Delete Course">
                                        <Popconfirm
                                            title="Are you sure to delete Course?"
                                            onConfirm={() => this.handleDelete(record._id)}
                                            okText="Yes"
                                            cancelText="No">
                                            <Button
                                                shape="circle"
                                                className={styles.btn}
                                                icon="delete" />
                                        </Popconfirm>
                                    </Tooltip>

                                    <Tooltip title="Transfer Course">
                                        <Popconfirm
                                            title="Are you sure to Transfer/Copy Course?"
                                            onConfirm={() => {
                                                this.handleTransfer(record)
                                            }}

                                            okText="Yes"
                                            cancelText="No">
                                            <Button
                                                className={styles.btn}
                                                size={'small'}
                                                style={{ marginLeft: '5px' }}
                                                shape="circle"
                                                icon="forward"
                                            />
                                        </Popconfirm>
                                    </Tooltip>
                                </>
                                :
                                <>
                                    <Tooltip title="Restore ">
                                        <Popconfirm
                                            title="Are you sure to restore Course?"
                                            onConfirm={() => this.restoreCourse(record._id)}
                                            okText="Yes"
                                            cancelText="No">
                                            <Button
                                                shape="circle"
                                                className={styles.btn}
                                            >Restore
                                            </Button>
                                        </Popconfirm>
                                    </Tooltip>
                                </>
                        }

                    </React.Fragment>
                )
            }
        ];

        return (
            <PageHeaderWrapper title={`All Course : ${this.state.total}`}>
                {
                    this.state.showTransferForm ? (
                        <TransferCourse courseId={this.state.courseId} universityId={this.state.universityId} alluniversity={this.state.uniArr} onClose={this.closeTransferForm} />
                    ) : null
                }
                {
                    this.state.showCourseFactSheetDrawer ?
                        <CourseFactSheet record={this.state.recordFactSheet} onClose={this.closeCourseFactSheetDrawer} />
                        : null
                }
                <Card style={{ marginBottom: 10 }}>
                    <Row>
                        <Col span={8}>
                            <h4>SEARCH BY UNIVERSITY</h4>
                            <Select
                                allowClear
                                showSearch={true}
                                style={{ width: '16rem' }}
                                value={this.state.courseUniversityId}
                                placeholder="Select University"
                                optionFilterProp="universityInstitutionName"
                                onChange={this.onUniChoose}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    );
                                }}
                            >
                                {this.state.uniArr.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val._id}>
                                            {val.universityInstitutionName}
                                        </Option>
                                    );
                                })}
                            </Select>
                        </Col>
                        <Col span={7}>
                            <h4>FILTER BY LAST UPDATE</h4>
                            <RangePicker
                                showTime={{ format: 'HH:mm' }}
                                format="YYYY-MM-DD HH:mm"
                                placeholder={['Start Time', 'End Time']}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            />
                        </Col>
                        {
                            CourseRestoreView ?
                                < >
                                    <Col span={2} style={{ marginLeft: '1rem', marginTop: '1.3rem' }}>
                                        <Button type={'default'}
                                            loading={this.state.restoreLoading}
                                            onClick={() => {
                                                this.setState({ showDelete: false }, () => {
                                                    this.table.current.reload();
                                                })
                                            }}>All Items</Button>
                                    </Col>
                                    <Col span={3} style={{ marginLeft: '1rem', marginTop: '1.3rem' }}>
                                        <Button type={'default'}
                                            loading={this.state.restoreLoading}
                                            onClick={() => {
                                                this.setState({ showDelete: true }, () => {
                                                    this.table.current.reload();
                                                })
                                            }}>Deleted Items</Button>
                                    </Col>
                                </>
                                : null
                        }
                        <Col span={2} style={{ float: 'right', marginTop: '1.3rem' }}>
                            <div >
                                <Link to='/master/add-course'><Button>Add</Button></Link>
                            </div>
                        </Col>
                    </Row>
                </Card>
                <Card style={{ marginBottom: 10, padding: '0px' }}>
                    <Row style={{ display: 'flex', alignItems: 'left', padding: '0px', margin: '0px' }}>
                        <Col span={4}>
                            <Button
                                type={'primary'}
                                style={{ textAlign: 'center', marginBottom: '0px' }}
                                onClick={() => { this.setState({ visible1: true }) }}
                            >Add Excel File</Button>
                        </Col>
                        <Col span={4}>
                            <Button
                                type={'primary'}
                                style={{ textAlign: 'center', marginBottom: '0px' }}
                                onClick={() => {
                                    this.setState({ showMissingQual: true }, () => {
                                        this.table.current.reload()
                                    })
                                }}
                            >Show Missing Qualification</Button>
                        </Col>
                        <Col span={4}>
                            <Button
                                type={'primary'}
                                style={{ textAlign: 'center', marginBottom: '0px' }}
                                onClick={this.exportExcel}
                            >Export Excel</Button>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true}>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 1400 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ["10", "20", "50", "100", "1000"],
                        }}
                    />
                </Card>
                {this.state.visible1 && <Drawer
                    title=""
                    placement="right"
                    closable={true}
                    onClose={() => {
                        this.setState({
                            visible1: false
                        })
                    }}
                    visible={this.state.visible1}
                    width={500}>
                    <div>
                        <Card bordered={true}>
                            <div>

                                <Form onSubmit={this.handleSubmit} {...formItemLayout} style={{ marginTop: 8 }}>
                                    <GetAllFormFields apiurl={LAPI_URL}
                                        inputSchema={inputTypes}
                                        getFieldDecorator={getFieldDecorator} />

                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ marginLeft: '10%' }}
                                        loading={this.state.loading}>
                                        UPLOAD

                                    </Button>

                                    <a href={CourseImportExcel} download={'course-sample.xlsx'}>
                                        <Button
                                            type="default"
                                            style={{ marginLeft: '10%' }}
                                            loading={this.state.loading}>
                                            DOWNLOAD SAMPLE FILE
                                        </Button>
                                    </a>
                                </Form>
                            </div>
                        </Card>
                    </div>
                </Drawer>}
            </PageHeaderWrapper>
        );
    }
}

const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search,
});
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllCourse);
